import { JSONTransformer } from '@atlaskit/editor-json-transformer';
import { DOMParser } from 'prosemirror-model';

import { type ADFDocument } from '@canvas/adf-types';

import { createEnhancedSchema } from './create-enhanced-schema.ts';

const transformer = new JSONTransformer();
const schema = createEnhancedSchema();
const domParser = DOMParser.fromSchema(schema);

/**
 * Converts an HTML string to an ADF document.
 * Returns `undefined` if the HTML cannot be parsed.
 */
export function htmlToAdfDocument(html: string): ADFDocument | undefined {
  try {
    const htmlDoc = new globalThis.DOMParser().parseFromString(html, 'text/html');
    const body = htmlDoc.body;
    if (!body) {
      return undefined;
    }
    const pmNode = domParser.parse(body);
    const adfDoc = transformer.encode(pmNode);
    return adfDoc as ADFDocument;
  } catch {
    return undefined;
  }
}
